export const isEmailFormat = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

export const isMatrixIdFormat = (matrixId: string): boolean => {
  const matrixIdRegex = /^@[a-zA-Z0-9._=-]+:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return matrixIdRegex.test(matrixId.trim());
};

export const isEmailOrMatrixIdFormat = (value: string): boolean => isEmailFormat(value) || isMatrixIdFormat(value);

const matrixIdWithoutAtRegex = /^[a-zA-Z0-9._=-]+:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const normalizeMatrixId = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed.startsWith('@') && matrixIdWithoutAtRegex.test(trimmed)) return `@${trimmed}`;
  return trimmed;
};

const normalizeInvitee = (invitee: string): string => (isEmailFormat(invitee) ? invitee.toLowerCase() : invitee);

export const isInviteeDuplicate = (input: string, invitees: string[]): boolean => {
  const trimmedInput = input.trim();
  if (!trimmedInput) return false;

  const normalizedInput = normalizeInvitee(trimmedInput);
  return invitees.some((invitee) => normalizeInvitee(invitee) === normalizedInput);
};
